const TRACTOR_DOUBLE_BOOKED_PREFIX = "TRACTOR_DOUBLE_BOOKED:";

export function getTractorDoubleBookingMessage(error: unknown): string | null {
  const message = error instanceof Error
    ? error.message
    : typeof error === "object" && error !== null && "message" in error
      ? String((error as { message?: unknown }).message ?? "")
      : String(error ?? "");

  const index = message.indexOf(TRACTOR_DOUBLE_BOOKED_PREFIX);
  if (index === -1) return null;

  const conflictId = message
    .slice(index + TRACTOR_DOUBLE_BOOKED_PREFIX.length)
    .split(/\s|\n|\r|\t/)[0]
    .trim();

  return conflictId
    ? `This tractor is already booked on ${conflictId} during that time window.`
    : "This tractor is already booked during that time window.";
}